import React, { useContext, memo } from 'react';
import { Snackbar, Button } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import ToastContext from './context';
import { Label } from '../label';
import useStyles from './toast.styles';

const Toast = () => {
  const classes = useStyles();
  const { type, message, action, label, clean, durationInSeconds = 6, placement = 'bottom' } = useContext(ToastContext);
  if (!type || !message) {
    return null;
  }
  return (
    <Snackbar
      anchorOrigin={{
        vertical: placement,
        horizontal: 'center'
      }}
      open
      autoHideDuration={1000 * durationInSeconds}
      onClose={clean}
      ContentProps={{
        className: type === 'error' ? classes.error : classes.content
      }}
      classes={{ anchorOriginBottomCenter: classes.bottom }}
      message={
        <Label type="toast" className={classes.toastLabel}>
          {type === 'error' && <ErrorOutlineIcon className={classes.icon} />}
          {message}
        </Label>
      }
      ClickAwayListenerProps={{
        mouseEvent: false
      }}
      action={
        action &&
        label && (
          <Button
            disableRipple
            className={classes.button}
            color="secondary"
            size="large"
            onClick={() => {
              clean();
              action();
            }}
          >
            {label}
          </Button>
        )
      }
    />
  );
};

export default memo(Toast);
